module.exports = __webpack_public_path__ + "media/images/logos/xponential-logo-6f3a6f1a72674bcb279e8b745cdedd8c.png";